import { LabelTag } from "features/labels/components";
import type { Label } from "features/labels/types";

export default function MobileLabels({ labels }: { labels: Label[] }) {
  return (
    <div className="flex gap-1 flex-wrap w-full">
      {labels.map((label) => (
        <LabelTag key={label.id} label={label} size="sm" />
      ))}
    </div>
  );
}
